import React, { useState, forwardRef, Ref } from 'react';
import { InputAdornment, FilledInput, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { TFunction } from 'react-i18next';

interface PasswordField {
  testId?: string;
  error?: boolean;
  placeholder?: string;
  errorMessage?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  t: TFunction<'translation'>;
}

const PasswordField = (
  { testId = 'password', onFocus, onBlur, error, placeholder, t, ...rest }: PasswordField,
  ref: Ref<HTMLDivElement>,
): JSX.Element => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FilledInput
      onFocus={onFocus}
      onBlur={onBlur}
      ref={ref}
      {...rest}
      error={error}
      inputProps={{ 'data-testid': testId }}
      placeholder={placeholder || `${t('ns.common:password:placeholder')}`}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => setShowPassword(!showPassword)}
            data-testid="password-visibility-btn"
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default forwardRef(PasswordField);
